//odemeok
import React, { useEffect, useState } from 'react';
import axios from "axios";
import { useTranslation } from 'react-i18next';

export const Packages = () => {
    const { t } = useTranslation();
    const [msg, setMsg] = useState([]);


    const getDataa = async () => {
        try {
            const headerss = {
                "accept": "*/*",
                'Access-Control-Allow-Credentials': 'false',
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json'
            }
            await axios({
                method: 'get',
                url: "https://express.heryerdeingilizce.com/sa",
                headers: headerss
            }).then(res => {
                console.log(res.data)

            }
            );

        }
        catch (err) {
            setMsg(err);
        }
    }

    useEffect(() => {
        getDataa();
    }, []);

    return (
        <div className="row">
            ödeme ok
        </div>
    )
}
export default Packages;